import Vue from 'vue'
import App from './App.vue'
import { LMap, LTileLayer } from 'vue2-leaflet'
import store from './store'
import router from './router'
import client from './api/client'
import * as Sentry from '@sentry/vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'flag-icons/css/flag-icons.min.css'
import 'leaflet/dist/leaflet.css'
import './assets/calendula.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas)

Sentry.init({
    Vue,
    dsn: 'https://28daef89816f71d2b97fe00ad8c7f455@o4511395339042816.ingest.us.sentry.io/4511395696410624',
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 1.0,
    sendDefaultPii: true,
})

Vue.config.productionTip = false

Vue.prototype.$api = client

Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')
